import React, { useState, useEffect } from 'react';
import axios from 'axios';

const DepartmentsTable = () => {
  const [departments, setDepartments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchDepartments = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/departments`);
        setDepartments(response.data);
      } catch (err) {
        console.error('Error fetching departments:', err);
        setError('Failed to fetch departments.');
      } finally {
        setLoading(false);
      }
    };

    fetchDepartments();
  }, []);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;

  return (
    <div className="container mt-4">
      <h2 className="mb-4 text-center">Departments</h2>
      <table className="table table-bordered">
        <thead>
          <tr>
            <th>Department ID</th>
            <th>Department Name</th>
            <th>Department Description</th>
          </tr>
        </thead>
        <tbody>
          {departments.length === 0 ? (
            <tr><td colSpan="3" className="text-center">No departments available</td></tr>
          ) : (
            departments.map((dept) => (
              <tr key={dept.deptId}>
                <td>{dept.deptId}</td>
                <td>{dept.deptName}</td>
                <td>{dept.deptDesc}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>
      
    </div>
  );
};

export default DepartmentsTable;
